import HtmlTrans from 'components/shared/HtmlTrans';
import { Heading1 } from 'components/shared/Typography';
import { useI18n } from 'hooks/useI18n';
import { getPublicPath } from 'utils/paths';
import {
  StyledContainer,
  StyledHero,
  StyledPreTitle,
  StyledWrapper
} from './ConsultancyHero.styled';

const ConsultancyHero: React.FC = () => {
  const { t } = useI18n('consultancy');

  return (
    <StyledHero>
      <StyledWrapper>
        <StyledContainer>
          <div>
            <StyledPreTitle>{t('consultancy.hero.pre-title')}</StyledPreTitle>
            <Heading1>
              <HtmlTrans
                ns={'consultancy'}
                i18nKey={'consultancy.hero.title'}
                components={{ br: <br /> }}
              />
            </Heading1>
            <HtmlTrans ns={'consultancy'} i18nKey={'consultancy.hero.desc'} />
          </div>
          <img src={getPublicPath(`/images/consultancy/Apes.svg`)} alt="" />
        </StyledContainer>
      </StyledWrapper>
    </StyledHero>
  );
};

export default ConsultancyHero;
